import { sample, createEffect } from 'effector';
import { delay } from 'patronum';
import { MOUNT_DELAY } from '@consts/delay';
import { $isAuthenticated } from '@features/common';
import { apiNewsFeed } from '../../api';
import { subscribeIds } from '../news-subscriber/news-subscriber.model';
import { PageGate, getNewsListByInterval, setNewsFeed, $params } from './news-feed.model';
import type { NewsFeedPayload, NewsFeedResponse, News } from './news-feed.types';

/* при маунте ленты новостей запрашиваю отдельным эффектом новости
  что бы после его завершения начать запрашивать новости через интервал
  и не было лишних проверок на новые записи

  Лента новостей монтируется отдельно от роутинга, поэтому нужен флаг $isAuthenticated
*/
const fxGetNewsListByMount = createEffect<NewsFeedPayload, NewsFeedResponse, Error>().use(
  apiNewsFeed.getNewsList
);

const delayedOpen = delay({
  source: sample(PageGate.open, $isAuthenticated),
  timeout: MOUNT_DELAY,
});

sample({
  clock: delayedOpen,
  source: $params,
  target: fxGetNewsListByMount,
});

sample({
  clock: fxGetNewsListByMount.done,
  fn: ({ result }) => result,
  target: [setNewsFeed, getNewsListByInterval, subscribeIds.prepend(takeID)],
});

function takeID({ news }: { news: News[] }): number[] {
  return news.map((item) => item.id);
}
